import styled from "styled-components";

const OutlinedBoxContainer = styled.div`
  border: 2px solid #454545;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  position: relative;
`;



export default OutlinedBoxContainer;
